/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { sigintUpdateSignal } from "../funcs/sigintUpdateSignal.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { SigintSignal } from "../models/components/sigintsignal.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateSigintSignalRequest,
  UpdateSigintSignalSecurity,
} from "../models/operations/updatesigintsignal.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateSigintSignalMutationVariables = {
  request: UpdateSigintSignalRequest;
  security?: UpdateSigintSignalSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateSigintSignalMutationData = SigintSignal;

export type UpdateSigintSignalMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateSignal sigint
 *
 * @remarks
 * Partially update a custom signal. Omitted fields and JSON null leave existing values unchanged. Supplying an empty optional-text value clears it. A supplied name is trimmed and must contain 1 to 200 characters.
 */
export function useUpdateSigintSignalMutation(
  options?: MutationHookOptions<
    UpdateSigintSignalMutationData,
    UpdateSigintSignalMutationError,
    UpdateSigintSignalMutationVariables
  >,
): UseMutationResult<
  UpdateSigintSignalMutationData,
  UpdateSigintSignalMutationError,
  UpdateSigintSignalMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateSigintSignalMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateSigintSignal(): MutationKey {
  return ["@gram/client", "sigint", "updateSignal"];
}

export function buildUpdateSigintSignalMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateSigintSignalMutationVariables,
  ) => Promise<UpdateSigintSignalMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateSigintSignal(),
    mutationFn: function updateSigintSignalMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateSigintSignalMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(sigintUpdateSignal(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
